// components/technologies/TechCategories.ts

export const staticTechCategories = [
  {
    id: "languages",
    color: "bg-gradient-to-r from-blue-500 to-cyan-400",
  },
  {
    id: "agentic",
    color: "bg-gradient-to-r from-amber-500 to-orange-400",
  },
  {
    id: "backend",
    color: "bg-gradient-to-r from-emerald-600 to-green-400",
  },
  {
    id: "frontend",
    color: "bg-gradient-to-r from-violet-600 to-purple-400",
  },
  {
    id: "cloud-ml",
    color: "bg-gradient-to-r from-indigo-500 to-blue-400",
  },
  {
    id: "others",
    color: "bg-gradient-to-r from-teal-500 to-cyan-400",
  },
];
